import { render } from "./addCompany.vue?vue&type=template&id=426a3a08"
import script from "./addCompany.vue?vue&type=script&lang=js"
export * from "./addCompany.vue?vue&type=script&lang=js"

import "./addCompany.vue?vue&type=style&index=0&id=426a3a08&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__